export default "__VITE_ASSET__4ooY$GNAdNTu9hT4_nR$9A__"